/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgManageGroups = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M1.998 2h9v9h-9zm2 2v5h5V4zm-2 9h9v9h-9zm2 2v5h5v-5zm9-2h9v9h-9zm2 2v5h5v-5zM16.5 3.145V2h2v1.145c.233.07.455.162.665.276l.81-.81 1.414 1.414-.81.81c.114.21.207.432.276.665H22v2h-1.145c-.07.233-.162.455-.276.665l.81.81-1.414 1.414-.81-.81a3.48 3.48 0 0 1-.665.276V11h-2V9.855a3.477 3.477 0 0 1-.665-.276l-.81.81-1.414-1.414.81-.81a3.476 3.476 0 0 1-.276-.665H13v-2h1.145c.07-.233.162-.455.276-.665l-.81-.81 1.414-1.414.81.81a3.44 3.44 0 0 1 .665-.276zM19 6.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgManageGroups as ManageGroups };
